import React from "react";
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Tooltip
} from "@material-ui/core";
import { Delete } from "@material-ui/icons";
import { TFunction } from "i18next";
import { ILocalTest } from "./helpers";

interface ITestsListProps {
    tests: ILocalTest[];
    onDeleteTest: (testId: string) => void;
    tLocal: TFunction;
}

const TestsList = (props: ITestsListProps) => {
    const { tests, onDeleteTest, tLocal } = props;

    const getTestName = (test: ILocalTest) => {
        if (test.testType === "answersToResults") {
            return (
                test.testName +
                " (" +
                tLocal(`answersToResultsNameToCalculateScore`, {
                    ns: "TESTNEW"
                }) +
                ": " +
                test.answersToResultsNameToCalculateScore +
                ")"
            );
        }
        return test.testName;
    };

    if (tests.length === 0) {
        return (
            <Box marginTop={2}>
                <Typography
                    variant="body1"
                    style={{
                        fontStyle: "italic",
                        marginBottom: 8,
                        fontWeight: 700
                    }}
                >
                    {tLocal("associatedTests")}
                </Typography>
                <Typography color="secondary" variant="body2">
                    {tLocal("noAssociatedTests")}
                </Typography>
            </Box>
        );
    }

    return (
        <Box marginTop={4}>
            <Typography
                variant="body1"
                style={{
                    fontStyle: "italic",
                    marginBottom: 8,
                    fontWeight: 700
                }}
            >
                {tLocal("associatedTests")}
            </Typography>
            <TableContainer>
                <Table aria-label="tests table" size="small">
                    <TableHead
                        style={{
                            backgroundColor: "#614F71"
                        }}
                    >
                        <TableRow>
                            <TableCell
                                style={{
                                    fontWeight: 600,
                                    color: "white"
                                }}
                            >
                                {tLocal("name", { ns: "TESTNEW" })}
                            </TableCell>
                            <TableCell
                                style={{
                                    fontWeight: 600,
                                    color: "white"
                                }}
                            >
                                {tLocal(`testType`, { ns: "TESTNEW" })}
                            </TableCell>
                            <TableCell
                                style={{
                                    fontWeight: 600,
                                    color: "white"
                                }}
                                align="right"
                            >
                                {tLocal("actions")}
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tests.map((test) => (
                            <TableRow
                                key={test.testId}
                                style={{
                                    backgroundColor: "#FFF6FF"
                                }}
                            >
                                <TableCell component="th" scope="row">
                                    {getTestName(test)}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {tLocal(`typeTest_${test.testType}`, {
                                        ns: "TESTNEW"
                                    })}
                                </TableCell>
                                <TableCell align="right">
                                    <Tooltip
                                        title={
                                            tLocal("COMPLEOGENERAL_Delete") ||
                                            "Delete"
                                        }
                                    >
                                        <IconButton
                                            size="small"
                                            onClick={() =>
                                                onDeleteTest(test.testId)
                                            }
                                        >
                                            <Delete color="secondary" />
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default TestsList;
